var _defs, _rect, _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartonMauvaisePosition2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "positions_porter_carton",
    "data-name": "positions porter carton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385 517.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-1{stroke-width:5px;}.cls-2{stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mauvaise r\xE9ponse 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.96,
    y: 351,
    width: 215.09,
    height: 144
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M873.91,1004c.85,42,14.36,137.6,20.27,173l24.49-2c-.85-40-4.23-206-7.6-218Z",
    transform: "translate(-789.5 -843)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1156.8,1137c-5-10-41.75-39.93-71-62.74,7.21-61.86,11-121.62.1-131.26C1062.22,922,982,915,982,915s-80.22,7-103.87,28c-10.85,9.64-7.11,69.4.1,131.26-29.28,22.81-66.05,52.71-71,62.74-8.44,17-15.2,208-15.2,208,0,19.27,34.62,16.27,34.62-3l33.78-182,28.4-7.24c6,40.32,11.29,70.24,11.29,70.24,1.71,17.54,23.66,14.54,21.95-3l-2.17-75.16L982,1129l62.13,15.84L1042,1220c-1.71,17.54,20.24,20.54,22,3,0,0,5.27-29.92,11.29-70.24l28.4,7.24,33.78,182c0,19.27,34.62,22.27,34.62,3C1172,1345,1165.24,1154,1156.8,1137Z",
    transform: "translate(-789.5 -843)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.09,1004c-.85,42-14.36,137.6-20.27,173l-24.49-2c.85-40,4.23-206,7.6-218Z",
    transform: "translate(-789.5 -843)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M915.29,987,922,1220c1.71,17.54-20.24,20.54-21.95,3,0,0-45.6-259-22-280",
    transform: "translate(-789.5 -843)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1049.18,987l-6.75,233c-1.71,17.54,20.24,20.54,22,3,0,0,45.6-259,22-280",
    transform: "translate(-789.5 -843)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 192.5,
    cy: 74,
    r: 71
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartonMauvaisePosition2);
export default __webpack_public_path__ + "static/media/carton_mauvaise_position_2.e9d28ffeb7299c7955f8220cf26ffeef.svg";
export { ForwardRef as ReactComponent };